import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, checkboxColumn } from "./ColumnHelpers";

export function column_ReadyToSample(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return checkboxColumn(context, "isReadyToSample", "isReadyToSample", { groupStateKey: "readySelectionState" });
}
